import Api from "../ApiUtility/Api";


class CK_Schemas {
  constructor() {
    this.api = new Api();
  }


  WS_CK_Schemas_List_GET(requestData) {
    return this.api.postAPI(requestData, '/dev/WS_CK_Schemas_List_GET')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during User Authentication API call :', error);
        throw error;
      });
  }
  WS_CK_Schema_Object_By_ID_GET(requestData) {
    return this.api
      .postAPI(requestData, "/dev/WS_CK_Schema_Object_By_ID_GET")
      .then((data) => {
        console.log("WS_CK_Schema_Object_By_ID_GET Response :", data);
        return data;
      })
      .catch((error) => {
        console.error("Error during WS_CK_Schema_Object_By_ID_GET API call:", error);
        throw error;
      });
  }
  WS_CK_Schema_INSERT(requestData) {
    return this.api
      .postAPI(requestData, "/dev/WS_CK_Schema_INSERT")
      .then((data) => {
        console.log("WS_CK_Schema_INSERT Response :", data);
        return data;
      })
      .catch((error) => {
        console.error("Error during WS_CK_Schema_INSERT API call:", error);
        throw error;
      });
  }
  WS_CK_Schema_ByID_UPDATE(requestData) {
    return this.api
      .postAPI(requestData, "/dev/WS_CK_Schema_ByID_UPDATE")
      .then((data) => {
        console.log("WS_CK_Schema_ByID_UPDATE Response:", data);
        return data;
      })
      .catch((error) => {
        console.error("Error during WS_CK_Schema_ByID_UPDATE API call:", error);
        throw error;
      });
  }
  CK_Dictionary_List_GET(requestData) {
    return this.api
      .postAPI(requestData, "/dev/WS_CK_Dictionary_List_GET")
      .then((data) => {
        console.log("WS_CK_Dictionary_List_GET Response:", data);
        return data;
      })
      .catch((error) => {
        console.error("Error during WS_CK_Dictionary_List_GET API call:", error);
        throw error;
      });
  }
  WS_CK_Dictionary_Items_ByID_GET(requestData) {
    return this.api
      .postAPI(requestData, "/dev/WS_CK_Dictionary_Items_ByID_GET")
      .then((data) => {
        console.log("WS_CK_Dictionary_Items_ByID_GET Response:", data);
        return data;
      })
      .catch((error) => {
        console.error("Error during WS_CK_Dictionary_Items_ByID_GET API call:", error);
        throw error;
      });
  }

  AP_Dataset_List_GET(requestData) {
    return this.api
      .postAPI(requestData, "/dev/WS_Dataset_List_GET")
      .then((data) => {
        console.log("Dataset List Response :", data);
        return data;
      })
      .catch((error) => {
        console.error("Error during Dataset List GET API call:", error);
        throw error;
      });
  }
}

export default CK_Schemas;